import React from 'react';
import cn from 'classnames';
import ReactPhoneInput from 'react-phone-input-2';

import './phone-input.scss';

const PhoneInput = ({
	label,
	name,
	value,
	onChange,
	onBlur,
	error,
	validationMessage,
	autoFill,
}) => (
	<div
		className={cn('phone-input-validator', {
			error: error || false,
		})}
	>
		{label && <div className="phone-input-validator-label">{label}</div>}
		<div className="phone-input-validator-wrapper">
			<ReactPhoneInput
				inputExtraProps={{
					name,
					autoComplete: autoFill,
				}}
				value={value}
				defaultCountry="pt"
				masks={{ pt: '+... ... ... ...' }}
				countryCodeEditable={false}
				onChange={onChange}
				onBlur={onBlur}
			/>
		</div>
		{error && validationMessage && (<div className="phone-input-validator-message">{validationMessage}</div>)}
	</div>
);

export default PhoneInput;
